import { normalizeFontFamilyName } from './normalize-font-family-name';
import { ProviderTypes } from './types';
var allFonts = [
    buildWebSafeFont("Helvetica" /* Helvetica */),
    buildWebSafeFont("Arial" /* Arial */),
    buildWebSafeFont("Verdana" /* Verdana */),
    buildWebSafeFont("Trebuchet ms" /* TrebuchetMs */),
    buildWebSafeFont("Georgia" /* Georgia */),
    buildWebSafeFont("Times new roman" /* TimeNewRoman */),
    buildWebSafeFont("Courier" /* Courier */),
    buildWebSafeFont("Comic sans" /* ComicSans */),
    buildWebSafeFont("Tahoma" /* Tahoma */),
    {
        cdnName: '',
        characterSets: [],
        displayName: 'Courier New',
        fallbacks: [],
        fontFamily: 'courier new',
        provider: ProviderTypes.system,
    },
    {
        cdnName: 'Niconne',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Niconne Regular',
        fallbacks: ['niconne', "Georgia" /* Georgia */],
        fontFamily: 'niconne-regular',
        provider: ProviderTypes.google,
    },
    {
        cdnName: '',
        characterSets: ['latin'],
        displayName: 'DIN Next LT Pro Light',
        fallbacks: [],
        fontFamily: 'dinnextlight',
        provider: ProviderTypes.system,
    },
    {
        cdnName: '',
        characterSets: [
            'latin',
            'latin-ext',
            'greek',
            'greek-ext',
            'cyrillic',
            'cyrillic-ext',
        ],
        displayName: 'Bodoni Poster',
        fallbacks: [],
        fontFamily: 'bodonistd poster',
        provider: ProviderTypes.system,
    },
    {
        cdnName: '',
        characterSets: ['latin'],
        displayName: 'ITC Arecibo',
        fallbacks: [],
        fontFamily: 'areciboitcstd',
        provider: ProviderTypes.system,
    },
    {
        cdnName: '',
        characterSets: ['latin'],
        displayName: 'Amatic SC',
        fallbacks: ["Comic sans" /* ComicSans */],
        fontFamily: 'amaticsc-regular',
        provider: ProviderTypes.system,
    },
    {
        cdnName: 'Roboto',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Roboto',
        fallbacks: ["Arial" /* Arial */],
        fontFamily: 'roboto',
        provider: ProviderTypes.system,
    },
    {
        cdnName: 'PlayfairDisplay',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        displayName: 'Playfair Display',
        fallbacks: ["Times new roman" /* TimeNewRoman */],
        fontFamily: 'playfair display',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'PlayfairDisplaySC',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        displayName: 'Playfair Display SC',
        fallbacks: ["Times new roman" /* TimeNewRoman */],
        fontFamily: 'playfair display sc',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Montserrat',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        displayName: 'Montserrat',
        fallbacks: ["Helvetica" /* Helvetica */],
        fontFamily: 'montserrat',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Raleway',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        displayName: 'Raleway',
        fallbacks: ["Verdana" /* Verdana */],
        fontFamily: 'raleway',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Pompiere',
        characterSets: [
            'latin',
            'latin-ext',
            'cyrillic',
            'cyrillic-ext',
            'greek',
            'greek-ext',
            'vietnamese',
        ],
        displayName: 'Pompiere',
        fallbacks: ["Trebuchet ms" /* TrebuchetMs */],
        fontFamily: 'pompiere',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'AmaticSC',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Amatic SC',
        fallbacks: [],
        fontFamily: 'amatic sc',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'FjallaOne',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Fjalla One',
        fallbacks: ["Tahoma" /* Tahoma */],
        fontFamily: 'fjalla one',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Lobster',
        characterSets: ['latin', 'latin-ext', 'vietnamese', 'cyrillic'],
        displayName: 'Lobster',
        fallbacks: ["Georgia" /* Georgia */],
        fontFamily: 'lobster',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Cookie',
        characterSets: ['latin'],
        displayName: 'Cookie',
        fallbacks: ["Comic sans" /* ComicSans */],
        fontFamily: 'cookie',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Pacifico',
        characterSets: ['latin'],
        displayName: 'Pacifico',
        fallbacks: ["Georgia" /* Georgia */],
        fontFamily: 'pacifico',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Overlock',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Overlock',
        fallbacks: ["Tahoma" /* Tahoma */],
        fontFamily: 'overlock',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'DancingScript',
        characterSets: ['latin'],
        displayName: 'Dancing Script',
        fallbacks: ["Times new roman" /* TimeNewRoman */],
        fontFamily: 'dancing script',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'OpenSans',
        characterSets: [
            'latin',
            'latin-ext',
            'greek',
            'greek-ext',
            'vietnamese',
            'cyrillic',
            'cyrillic-ext',
        ],
        displayName: 'Open Sans',
        fallbacks: ["Arial" /* Arial */],
        fontFamily: 'open sans',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'OpenSansCondensed',
        characterSets: [
            'latin',
            'latin-ext',
            'greek',
            'greek-ext',
            'vietnamese',
            'cyrillic',
            'cyrillic-ext',
        ],
        displayName: 'Open Sans Condensed',
        fallbacks: ["Arial" /* Arial */],
        fontFamily: 'open sans condensed',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Jura',
        characterSets: ['latin', 'latin-ext', 'greek', 'cyrillic', 'cyrillic-ext'],
        displayName: 'Jura',
        fallbacks: ["Verdana" /* Verdana */],
        fontFamily: 'jura',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'TitilliumWeb',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Titillium Web',
        fallbacks: ["Tahoma" /* Tahoma */],
        fontFamily: 'titillium web',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'DroidSerif',
        characterSets: ['latin'],
        displayName: 'Droid Serif',
        fallbacks: [],
        fontFamily: 'droid serif',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'NixieOne',
        characterSets: ['latin'],
        displayName: 'Nixie One',
        fallbacks: ["Courier" /* Courier */],
        fontFamily: 'nixie one',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'FrederickatheGreat',
        characterSets: ['latin'],
        displayName: 'Fredericka The Great',
        fallbacks: ["Times new roman" /* TimeNewRoman */],
        fontFamily: 'fredericka the great',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Lato',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Lato',
        fallbacks: ["Tahoma" /* Tahoma */],
        fontFamily: 'Lato',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Rochester',
        characterSets: ['latin'],
        displayName: 'Rochester',
        fallbacks: ["Georgia" /* Georgia */],
        fontFamily: 'Rochester',
        provider: ProviderTypes.google,
    },
    {
        cdnName: 'Righteous',
        characterSets: ['latin', 'latin-ext'],
        displayName: 'Righteous',
        fallbacks: ["Helvetica" /* Helvetica */],
        fontFamily: 'Righteous',
        provider: ProviderTypes.google,
    },
];
function buildWebSafeFont(name, fallbacks) {
    if (fallbacks === void 0) { fallbacks = []; }
    return {
        cdnName: '',
        characterSets: [],
        displayName: name,
        fallbacks: fallbacks || [],
        fontFamily: name.toLowerCase(),
        provider: ProviderTypes.webSafe,
    };
}
var normalizedFonts = allFonts.map(function (_a) {
    var cdnName = _a.cdnName, characterSets = _a.characterSets, displayName = _a.displayName, fallbacks = _a.fallbacks, fontFamily = _a.fontFamily, provider = _a.provider;
    return ({
        cdnName: cdnName,
        cdnSubsets: characterSets.join(','),
        fallbacks: fallbacks.join(','),
        fontFamily: fontFamily,
        normalizedDisplayName: normalizeFontFamilyName(displayName),
        normalizedFontFamily: normalizeFontFamilyName(fontFamily),
        provider: provider,
    });
});
export default normalizedFonts;
//# sourceMappingURL=fonts.js.map